import * as Yup from "yup";

const step4ValidationSchema = Yup.object().shape({
  paymentDetails: Yup.object().shape({
    paymentMethod: Yup.string().required('Payment Method is required'),
    cardDetails: Yup.object().shape({
      CardType: Yup.string().required('Card Type is required'),
      EncryptedCardNumber: Yup.mixed().required('Card Number is required'),
      ExpirationYear: Yup.number().required('Expiration Year is required'),
      ExpirationMonth: Yup.number().required('Expiration Month is required'),
      CVV: Yup.string()
        .required('CVV is required')
        .matches(/^\d{3,4}$/, 'CVV must be 3 or 4 digits'),
    }),
  }),
});
export default step4ValidationSchema;
